<script>
import { mapGetters } from 'vuex'
import { currencySymbol } from '@helper/currencySymbol'

export default {
  name: 'TutorListHeader',
  computed: {
    ...mapGetters('local', ['getListTitle']),
    currency () {
      return currencySymbol(this.getListTitle?.currency)
    }
  }
}
</script>

<template>
  <div class="container px-0">
    <p class="header-list">
      <span>{{ getListTitle.course_name }}</span>
      <span>tutor from</span>
      <span class="header-list__price">{{ currency }}{{ getListTitle.minimum_price }}</span>
      <span>{{ $t('labels.per', {unit: getListTitle.session_time}) }}</span>
    </p>
  </div>
</template>

<style scoped lang="scss">
.header-list {
  @apply text-body-1 lg:text__body-2-md--regular text__headline-5-xs--regular;
  &__price {
    @apply text-title lg:text__headline-5-md--bold text__headline-4-xs--bold;
  }
}
</style>
